module.exports = "<div class=\"custom-container\">\n        <div id=\"geochart-colors\" style=\"border-radius: 10px\"></div>\n</div>\n\n"